module.exports = __webpack_public_path__ + "static/media/img2.2d9d7248.jpg";